export default {
	install(Vue) {
		if (process.env.NODE_ENV !== 'production') {
			Vue.mixin({
				mounted() {
					//Check for a name on the component first
					let cmpName = this.$options.name;

					//If no name, check for a tag in the vnode
					if (!cmpName && this.$vnode && this.$vnode.componentOptions) {
						cmpName = this.$vnode.componentOptions.tag;
					}

					//If there's a name, set it as a data-cmp attribute on the element
					if (cmpName && this.$el && this.$el.setAttribute) {
						this.$el.setAttribute('data-cmp', cmpName);
					}
				}
			});
		}
	}
};